let isLoadingMore = false;
let infiniteObserver = null;

const stopInfinite = () => {
  if (infiniteObserver) infiniteObserver.disconnect();
  document.querySelectorAll('.js-infinite-scroll').forEach(s => { s.style.display = 'none'; });
};

const rearmInfinite = () => {
  if (!infiniteObserver) return;
  document.querySelectorAll('.js-infinite-scroll').forEach(s => {
    infiniteObserver.unobserve(s);
    infiniteObserver.observe(s);
  });
};

const loadItems = (trigger) => {
  if (isLoadingMore) return;

  const totalPages = parseInt($('[data-total-pages]').val());
  const nextPage = parseInt($('[data-current-page]').val()) + 1;
  if (nextPage > totalPages) { stopInfinite(); return; }

  isLoadingMore = true;
  let loadedOk = false;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + nextPage);

  trigger.setAttribute('disabled', '');
  trigger.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
      $('[data-current-page]').val(nextPage).attr('data-current-page', nextPage);
      loadedOk = true;
    },
    complete: function () {
      isLoadingMore = false;
      trigger.removeAttribute('disabled');
      trigger.classList.remove('loading');

      if (loadedOk && nextPage >= totalPages) {
        stopInfinite();
        document.querySelectorAll('.js-load-more').forEach(b => b.remove());
      } else if (loadedOk) {
        rearmInfinite();
      }
    }
  });
};

const checkVisibility = () => {
  if (infiniteObserver) infiniteObserver.disconnect();
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  if (!spinnerList.length) return;

  infiniteObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) loadItems(entry.target);
    });
  }, { rootMargin: '200px 0px' });

  spinnerList.forEach(spinner => infiniteObserver.observe(spinner));
};

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => { loadItems(button); };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();